// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PatientDetails-module__font-s-10___uY7DG {
  font-size: 10px !important;
}

.PatientDetails-module__font-s-12___HDpTp {
  font-size: 12px !important;
}

.PatientDetails-module__font-s-13___oxtm0 {
  font-size: 13px !important;
}

.PatientDetails-module__font-s-14___Q9bJM {
  font-size: 14px !important;
}

.PatientDetails-module__font-s-15____yCAJ {
  font-size: 15px !important;
}

.PatientDetails-module__font-s-16___c9HAU {
  font-size: 16px !important;
}

.PatientDetails-module__font-s-18___dGXSN {
  font-size: 18px !important;
}

.PatientDetails-module__font-s-20___gmlse {
  font-size: 20px !important;
}

.PatientDetails-module__font-s-22___Nz6kS {
  font-size: 22px !important;
}

.PatientDetails-module__font-s-28___Tx66_ {
  font-size: 28px !important;
}

.PatientDetails-module__font-w-400___ti_jK {
  font-weight: 400 !important;
}

.PatientDetails-module__font-w-500___vq_vy {
  font-weight: 500 !important;
}

.PatientDetails-module__font-w-600___Jeh07 {
  font-weight: 600 !important;
}

.PatientDetails-module__font-w-700___Osh4y {
  font-weight: 700 !important;
}

.PatientDetails-module__p-5___iVhqD {
  padding: 5px !important;
}

.PatientDetails-module__p-12___ufzlJ {
  padding: 12px !important;
}

.PatientDetails-module__p-16___GGozp {
  padding: 16px !important;
}

.PatientDetails-module__p-30___m8Gwf {
  padding: 30px !important;
}

.PatientDetails-module__p-b-0___ILaLL {
  padding-bottom: 0 !important;
}

.PatientDetails-module__p-b-5___tVc2j {
  padding-bottom: 5px !important;
}

.PatientDetails-module__p-b-10___ZkCua {
  padding-bottom: 10px !important;
}

.PatientDetails-module__p-b-12___mmEJk {
  padding-bottom: 12px !important;
}

.PatientDetails-module__p-b-16___jRJ9Z {
  padding-bottom: 16px !important;
}

.PatientDetails-module__p-b-18___bBn9K {
  padding-bottom: 18px !important;
}

.PatientDetails-module__p-b-20___J4cOC {
  padding-bottom: 20px !important;
}

.PatientDetails-module__p-b-25___oVGXW {
  padding-bottom: 25px !important;
}

.PatientDetails-module__p-b-30___FJzDm {
  padding-bottom: 30px !important;
}

.PatientDetails-module__p-b-50___tFgo4 {
  padding-bottom: 50px !important;
}

.PatientDetails-module__p-t-0___kvw0S {
  padding-top: 0 !important;
}

.PatientDetails-module__p-t-12___bmo3u {
  padding-top: 12px !important;
}

.PatientDetails-module__p-t-16___vNYg7 {
  padding-top: 16px !important;
}

.PatientDetails-module__p-t-18___ISyYM {
  padding-top: 18px !important;
}

.PatientDetails-module__p-t-20___gHcW9 {
  padding-top: 20px !important;
}

.PatientDetails-module__p-t-30___bppbN {
  padding-top: 30px !important;
}

.PatientDetails-module__p-t-40___FXQk8 {
  padding-top: 40px !important;
}

.PatientDetails-module__p-t-50___i1yCL {
  padding-top: 50px !important;
}

.PatientDetails-module__p-l-20___CUhu6 {
  padding-left: 20px !important;
}

.PatientDetails-module__p-l-30___8zHfV {
  padding-left: 30px !important;
}

.PatientDetails-module__p-l-40___qcOf3 {
  padding-left: 40px !important;
}

.PatientDetails-module__p-r-16___jdGIA {
  padding-right: 16px !important;
}

.PatientDetails-module__p-r-20___WRRUc {
  padding-right: 20px !important;
}

.PatientDetails-module__p-r-30___KJf1N {
  padding-right: 30px !important;
}

.PatientDetails-module__p-r-50___rS3yB {
  padding-right: 50px !important;
}

.PatientDetails-module__p-r-60___bDIQ2 {
  padding-right: 60px !important;
}

.PatientDetails-module__m-b-1___Ak7gR {
  margin-bottom: 1px !important;
}

.PatientDetails-module__m-b-2___p6YeF {
  margin-bottom: 2px !important;
}

.PatientDetails-module__m-b-6___tTIku {
  margin-bottom: 6px !important;
}

.PatientDetails-module__m-b-8___HTe1K {
  margin-bottom: 8px !important;
}

.PatientDetails-module__m-b-10___KOblY {
  margin-bottom: 10px !important;
}

.PatientDetails-module__m-b-14___e8HG9 {
  margin-bottom: 14px !important;
}

.PatientDetails-module__m-b-16___K7fdP {
  margin-bottom: 16px !important;
}

.PatientDetails-module__m-b-20___CZIrP {
  margin-bottom: 20px !important;
}

.PatientDetails-module__m-b-22___Itfg4 {
  margin-bottom: 22px !important;
}

.PatientDetails-module__m-b-24___Ao6pU {
  margin-bottom: 24px !important;
}

.PatientDetails-module__m-b-30___S8Urx {
  margin-bottom: 30px !important;
}

.PatientDetails-module__m-b-32___iJ7At {
  margin-bottom: 32px !important;
}

.PatientDetails-module__m-b-40___uDWSR {
  margin-bottom: 40px !important;
}

.PatientDetails-module__m-t-2___pxgVK {
  margin-top: 2px !important;
}

.PatientDetails-module__m-t-3___fEhUF {
  margin-top: 3px !important;
}

.PatientDetails-module__m-t-4___ZBJ0B {
  margin-top: 4px !important;
}

.PatientDetails-module__m-t-5___WxFMB {
  margin-top: 5px !important;
}

.PatientDetails-module__m-t-8___ZGbSY {
  margin-top: 8px !important;
}

.PatientDetails-module__m-t-10___C5qcU {
  margin-top: 10px !important;
}

.PatientDetails-module__m-t-15___D7Vux {
  margin-top: 15px !important;
}

.PatientDetails-module__m-t-16___cTpYY {
  margin-top: 16px !important;
}

.PatientDetails-module__m-t-20___aidOl {
  margin-top: 20px !important;
}

.PatientDetails-module__m-t-22___gUemx {
  margin-top: 22px !important;
}

.PatientDetails-module__m-t-30___NCjYQ {
  margin-top: 30px !important;
}

.PatientDetails-module__m-t-32___lm98h {
  margin-top: 32px !important;
}

.PatientDetails-module__m-l-auto___Nr4rA {
  margin-left: auto !important;
}

.PatientDetails-module__m-l-4___FC9jV {
  margin-left: 4px !important;
}

.PatientDetails-module__m-l-5___ncL9v {
  margin-left: 5px !important;
}

.PatientDetails-module__m-l-6___xDTOm {
  margin-left: 6px !important;
}

.PatientDetails-module__m-l-8___ITjI8 {
  margin-left: 8px !important;
}

.PatientDetails-module__m-l-10___Tzity {
  margin-left: 10px !important;
}

.PatientDetails-module__m-l-16___CDqVb {
  margin-left: 16px !important;
}

.PatientDetails-module__m-l-20___TmYI8 {
  margin-left: 20px !important;
}

.PatientDetails-module__m-l-24___BTkxq {
  margin-left: 24px !important;
}

.PatientDetails-module__m-l-30___bAWNy {
  margin-left: 30px !important;
}

.PatientDetails-module__m-l-35___JMciS {
  margin-left: 35px !important;
}

.PatientDetails-module__m-l-40___KDYTE {
  margin-left: 40px !important;
}

.PatientDetails-module__m-r-8___HTvxv {
  margin-right: 8px !important;
}

.PatientDetails-module__m-r-10___vASYJ {
  margin-right: 10px !important;
}

.PatientDetails-module__m-r-16___P0NxY {
  margin-right: 16px !important;
}

.PatientDetails-module__m-r-20___tj5DN {
  margin-right: 20px !important;
}

.PatientDetails-module__m-r-24___w6Cbw {
  margin-right: 24px !important;
}

.PatientDetails-module__m-r-30___rOCpC {
  margin-right: 30px !important;
}

.PatientDetails-module__m-r-40___UmpzM {
  margin-right: 40px !important;
}

.PatientDetails-module__border-r-3___peIg4 {
  border-radius: 3px !important;
}

.PatientDetails-module__border-r-4___DBX34 {
  border-radius: 4px !important;
}

.PatientDetails-module__border-r-6___TbbV7 {
  border-radius: 6px !important;
}

.PatientDetails-module__border-r-10___jJdfq {
  border-radius: 10px !important;
}

.PatientDetails-module__border-r-12___aVjX_ {
  border-radius: 12px !important;
}

.PatientDetails-module__border-r-16___Z6yIL {
  border-radius: 16px !important;
}

.PatientDetails-module__border-r-50___No3Ly {
  border-radius: 50% !important;
}

.PatientDetails-module__primary-border___ueYJs {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientDetails-module__primary-border-b____vyti {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientDetails-module__primary-border-t___Fl5Yk {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientDetails-module__primary-border-l___NaW1R {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientDetails-module__primary-border-r___BEdJ1 {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientDetails-module__secondary-border___Skbkp {
  border: 1px solid #637768;
}

.PatientDetails-module__secondary-border-b___yJZdQ {
  border-bottom: 1px solid #637768;
}

.PatientDetails-module__secondary-border-t___WywP7 {
  border-top: 1px solid #637768;
}

.PatientDetails-module__secondary-border-l___d28LX {
  border-left: 1px solid #637768;
}

.PatientDetails-module__secondary-border-r___CWXxL {
  border-right: 1px solid #637768;
}

.PatientDetails-module__gap-0___VQIOP {
  gap: 0 !important;
}

.PatientDetails-module__gap-2___v4a8D {
  gap: 2px !important;
}

.PatientDetails-module__gap-4___sGlDf {
  gap: 4px !important;
}

.PatientDetails-module__gap-5___FfdNK {
  gap: 5px !important;
}

.PatientDetails-module__gap-6___P7apg {
  gap: 6px !important;
}

.PatientDetails-module__gap-8___dK8uE {
  gap: 8px !important;
}

.PatientDetails-module__gap-10___EYUba {
  gap: 10px !important;
}

.PatientDetails-module__gap-12___cxVVc {
  gap: 12px !important;
}

.PatientDetails-module__gap-14___AIzY4 {
  gap: 14px !important;
}

.PatientDetails-module__gap-16___ItCVv {
  gap: 16px !important;
}

.PatientDetails-module__gap-18___U1ThU {
  gap: 18px !important;
}

.PatientDetails-module__gap-20___hmvkC {
  gap: 20px !important;
}

.PatientDetails-module__gap-24___tZKgj {
  gap: 24px !important;
}

.PatientDetails-module__gap-26___YG8E9 {
  gap: 26px !important;
}

.PatientDetails-module__gap-30___L7Hu6 {
  gap: 30px !important;
}

.PatientDetails-module__gap-32___mPXnB {
  gap: 32px !important;
}

.PatientDetails-module__gap-40___WgUs1 {
  gap: 40px !important;
}

.PatientDetails-module__gap-50___e9yGG {
  gap: 50px !important;
}

.PatientDetails-module__flex-1___EGcSc {
  flex: 1;
}

.PatientDetails-module__flex-none___ygNx5 {
  flex: none !important;
}

.PatientDetails-module__flex-column___eMoTq {
  display: flex;
  flex-direction: column !important;
}

.PatientDetails-module__flex-row___nlJ38 {
  display: flex;
  flex-direction: row !important;
}

.PatientDetails-module__vertically-centered___rKEAW {
  display: flex;
  align-items: center !important;
}

.PatientDetails-module__horizontally-centered___OwzS4 {
  display: flex;
  justify-content: center !important;
}

.PatientDetails-module__horizontally-end___Iq4Wl {
  display: flex;
  justify-content: end !important;
}

.PatientDetails-module__vertically-start___N5dMI {
  display: flex;
  align-items: start !important;
}

.PatientDetails-module__space-between___znsHb {
  display: flex;
  justify-content: space-between !important;
}

.PatientDetails-module__flex-wrap___L_lR3 {
  flex-wrap: wrap !important;
}

.PatientDetails-module__height-100___pgGfV {
  height: 100%;
}

.PatientDetails-module__width-50___Qyn3f {
  width: 50% !important;
}

.PatientDetails-module__width-100___KF3ev {
  width: 100%;
}

.PatientDetails-module__cursor-pointer___NW3Df {
  cursor: pointer;
}

.PatientDetails-module__cursor-not-allowed___KbP0U {
  cursor: not-allowed !important;
}

.PatientDetails-module__absolute-centered___ujZpX {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.PatientDetails-module__absolute___gtNsu {
  position: absolute;
}

.PatientDetails-module__relative___tm5eX {
  position: relative;
}

.PatientDetails-module__fixed___L3lmI {
  position: fixed;
}

.PatientDetails-module__visible___s0oRz {
  opacity: 1;
}

.PatientDetails-module__invisible___Z7HFW {
  opacity: 0;
}

.PatientDetails-module__col-90___gRmRr {
  width: 90% !important;
}

.PatientDetails-module__col-auto___Kb0dZ {
  width: auto !important;
}

.PatientDetails-module__medical-tabs___dSsY4 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.PatientDetails-module__medical-table-new___sFqPL {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.PatientDetails-module__medical-table-new___sFqPL:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.PatientDetails-module__medical-table-new___sFqPL::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.PatientDetails-module__medical-table-new___sFqPL::-webkit-scrollbar-track {
  display: none;
}
.PatientDetails-module__medical-table-new___sFqPL.PatientDetails-module__no-pagination___Htx3D {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.PatientDetails-module__medical-table-new___sFqPL.PatientDetails-module__no-pagination___Htx3D:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.PatientDetails-module__medical-table-new___sFqPL.PatientDetails-module__no-pagination___Htx3D::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.PatientDetails-module__medical-table-new___sFqPL.PatientDetails-module__no-pagination___Htx3D::-webkit-scrollbar-track {
  display: none;
}

.PatientDetails-module__medical-table-empty___wHRK1 {
  padding: 14px 40px !important;
}

.PatientDetails-module__icon-btn___HOLt_ {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.PatientDetails-module__search-icon___wAXbB {
  width: 24px;
  height: 24px;
  align-self: center;
}

.PatientDetails-module__disable-select___txWaJ {
  user-select: none;
}

.PatientDetails-module__break-word___IXdYA {
  word-break: break-word;
}

.PatientDetails-module__popup-clear-btn___l0thX {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.PatientDetails-module__scroll-m-b-20___Uthqt {
  scroll-margin-bottom: 20px;
}

.PatientDetails-module__section___wwB2Z {
  flex: 1;
}
.PatientDetails-module__section___wwB2Z .PatientDetails-module__statusText___MLvNJ {
  font-family: var(--font-family);
  font-weight: 400;
  background-color: #f86363;
  color: white;
  height: 39px;
}
.PatientDetails-module__section___wwB2Z .PatientDetails-module__statusText___MLvNJ.PatientDetails-module__yellow___G7iQ7 {
  background-color: rgba(241, 191, 114, 0.5);
  color: black;
}
.PatientDetails-module__section___wwB2Z .PatientDetails-module__master___jje2R {
  height: calc(100vh - var(--top-navigation) - var(--patient-details-header) - var(--patient-details-footer) - 6px);
}
.PatientDetails-module__section___wwB2Z .PatientDetails-module__master___jje2R .PatientDetails-module__detailSection___Ma9wV {
  width: calc(100vw - 270px);
  overflow: hidden;
}
.PatientDetails-module__section___wwB2Z .PatientDetails-module__master___jje2R .PatientDetails-module__aside___T1J58 {
  height: calc(100vh - var(--top-navigation) - var(--patient-details-header));
  overflow-y: scroll;
  overflow-x: hidden;
}
.PatientDetails-module__section___wwB2Z .PatientDetails-module__master___jje2R .PatientDetails-module__aside___T1J58:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.PatientDetails-module__section___wwB2Z .PatientDetails-module__master___jje2R .PatientDetails-module__aside___T1J58::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.PatientDetails-module__section___wwB2Z .PatientDetails-module__master___jje2R .PatientDetails-module__aside___T1J58::-webkit-scrollbar-track {
  display: none;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/PatientDetails.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss","webpack://./../common/src/styles/global/_weights.scss","webpack://./../common/src/styles/global/_sizes.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,OAAA;AA8pBF;AA5pBE;EEqBA,+BApBO;EAqBP,gBCzBQ;EHKN,yBAAA;EACA,YAAA;EACA,YIYoB;AJmpBxB;AA7pBI;EACE,0CAAA;EACA,YAAA;AA+pBN;AA3pBE;EACE,iHAAA;AA6pBJ;AAxpBI;EACE,0BAAA;EACA,gBAAA;AA0pBN;AAvpBI;EClBF,2EDmB4B;EClB5B,kBAAA;EACA,kBAAA;AD4qBF;AC1qBE;EACE,oCAAA;EACA,mBAAA;AD4qBJ;ACzqBE;EACE,UAAA;EACA,6BAAA;AD2qBJ;ACxqBE;EACE,aAAA;AD0qBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.section {\n  flex: 1;\n\n  .statusText {\n    @include get-font($roboto, $regular);\n    background-color: get-color(red);\n    color: get-color(white);\n    height: $patient-status-banner;\n\n    &.yellow {\n      background-color: rgba(241, 191, 114, 0.5);\n      color: black;\n    }\n  }\n\n  .master {\n    height: calc(\n      100vh - var(--top-navigation) - var(--patient-details-header) - var(--patient-details-footer) -\n        6px\n    );\n\n    .detailSection {\n      width: calc(100vw - 270px);\n      overflow: hidden;\n    }\n\n    .aside {\n      @include verticalScroll(calc(100vh - var(--top-navigation) - var(--patient-details-header)));\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n","$extra-light: 200;\n$light: 300;\n$regular: 400;\n$medium: 500;\n$semi-bold: 600;\n$bold: 700;\n$heavy: 900;\n","// font sizes\n$font-sizes: (\n  xx-small: 0.7rem,\n  x-small: 0.8rem,\n  small: 0.9rem,\n  medium: 1rem,\n  large: 1.2rem,\n  x-large: 1.5rem,\n  xx-large: 1.7rem,\n  xxx-large: 1.9rem,\n  header: 2.5rem,\n  largeButton: 1rem,\n);\n\n// component heights\n$top-navigation: 53px;\n$top-header: 62px;\n$nav-header: 70px;\n$settings-header: 62px;\n$documentation-tabs: 49px;\n$patient-details-header: 68px;\n$patient-status-banner: 39px;\n\n// breakpoints\n$breakpoint-desktop-large: 1600px;\n$breakpoint-desktop: 1250px;\n$breakpoint-tablet: 992px;\n$breakpoint-phone: 688px;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `PatientDetails-module__font-s-10___uY7DG`,
	"fontS12": `PatientDetails-module__font-s-12___HDpTp`,
	"fontS13": `PatientDetails-module__font-s-13___oxtm0`,
	"fontS14": `PatientDetails-module__font-s-14___Q9bJM`,
	"fontS15": `PatientDetails-module__font-s-15____yCAJ`,
	"fontS16": `PatientDetails-module__font-s-16___c9HAU`,
	"fontS18": `PatientDetails-module__font-s-18___dGXSN`,
	"fontS20": `PatientDetails-module__font-s-20___gmlse`,
	"fontS22": `PatientDetails-module__font-s-22___Nz6kS`,
	"fontS28": `PatientDetails-module__font-s-28___Tx66_`,
	"fontW400": `PatientDetails-module__font-w-400___ti_jK`,
	"fontW500": `PatientDetails-module__font-w-500___vq_vy`,
	"fontW600": `PatientDetails-module__font-w-600___Jeh07`,
	"fontW700": `PatientDetails-module__font-w-700___Osh4y`,
	"p5": `PatientDetails-module__p-5___iVhqD`,
	"p12": `PatientDetails-module__p-12___ufzlJ`,
	"p16": `PatientDetails-module__p-16___GGozp`,
	"p30": `PatientDetails-module__p-30___m8Gwf`,
	"pB0": `PatientDetails-module__p-b-0___ILaLL`,
	"pB5": `PatientDetails-module__p-b-5___tVc2j`,
	"pB10": `PatientDetails-module__p-b-10___ZkCua`,
	"pB12": `PatientDetails-module__p-b-12___mmEJk`,
	"pB16": `PatientDetails-module__p-b-16___jRJ9Z`,
	"pB18": `PatientDetails-module__p-b-18___bBn9K`,
	"pB20": `PatientDetails-module__p-b-20___J4cOC`,
	"pB25": `PatientDetails-module__p-b-25___oVGXW`,
	"pB30": `PatientDetails-module__p-b-30___FJzDm`,
	"pB50": `PatientDetails-module__p-b-50___tFgo4`,
	"pT0": `PatientDetails-module__p-t-0___kvw0S`,
	"pT12": `PatientDetails-module__p-t-12___bmo3u`,
	"pT16": `PatientDetails-module__p-t-16___vNYg7`,
	"pT18": `PatientDetails-module__p-t-18___ISyYM`,
	"pT20": `PatientDetails-module__p-t-20___gHcW9`,
	"pT30": `PatientDetails-module__p-t-30___bppbN`,
	"pT40": `PatientDetails-module__p-t-40___FXQk8`,
	"pT50": `PatientDetails-module__p-t-50___i1yCL`,
	"pL20": `PatientDetails-module__p-l-20___CUhu6`,
	"pL30": `PatientDetails-module__p-l-30___8zHfV`,
	"pL40": `PatientDetails-module__p-l-40___qcOf3`,
	"pR16": `PatientDetails-module__p-r-16___jdGIA`,
	"pR20": `PatientDetails-module__p-r-20___WRRUc`,
	"pR30": `PatientDetails-module__p-r-30___KJf1N`,
	"pR50": `PatientDetails-module__p-r-50___rS3yB`,
	"pR60": `PatientDetails-module__p-r-60___bDIQ2`,
	"mB1": `PatientDetails-module__m-b-1___Ak7gR`,
	"mB2": `PatientDetails-module__m-b-2___p6YeF`,
	"mB6": `PatientDetails-module__m-b-6___tTIku`,
	"mB8": `PatientDetails-module__m-b-8___HTe1K`,
	"mB10": `PatientDetails-module__m-b-10___KOblY`,
	"mB14": `PatientDetails-module__m-b-14___e8HG9`,
	"mB16": `PatientDetails-module__m-b-16___K7fdP`,
	"mB20": `PatientDetails-module__m-b-20___CZIrP`,
	"mB22": `PatientDetails-module__m-b-22___Itfg4`,
	"mB24": `PatientDetails-module__m-b-24___Ao6pU`,
	"mB30": `PatientDetails-module__m-b-30___S8Urx`,
	"mB32": `PatientDetails-module__m-b-32___iJ7At`,
	"mB40": `PatientDetails-module__m-b-40___uDWSR`,
	"mT2": `PatientDetails-module__m-t-2___pxgVK`,
	"mT3": `PatientDetails-module__m-t-3___fEhUF`,
	"mT4": `PatientDetails-module__m-t-4___ZBJ0B`,
	"mT5": `PatientDetails-module__m-t-5___WxFMB`,
	"mT8": `PatientDetails-module__m-t-8___ZGbSY`,
	"mT10": `PatientDetails-module__m-t-10___C5qcU`,
	"mT15": `PatientDetails-module__m-t-15___D7Vux`,
	"mT16": `PatientDetails-module__m-t-16___cTpYY`,
	"mT20": `PatientDetails-module__m-t-20___aidOl`,
	"mT22": `PatientDetails-module__m-t-22___gUemx`,
	"mT30": `PatientDetails-module__m-t-30___NCjYQ`,
	"mT32": `PatientDetails-module__m-t-32___lm98h`,
	"mLAuto": `PatientDetails-module__m-l-auto___Nr4rA`,
	"mL4": `PatientDetails-module__m-l-4___FC9jV`,
	"mL5": `PatientDetails-module__m-l-5___ncL9v`,
	"mL6": `PatientDetails-module__m-l-6___xDTOm`,
	"mL8": `PatientDetails-module__m-l-8___ITjI8`,
	"mL10": `PatientDetails-module__m-l-10___Tzity`,
	"mL16": `PatientDetails-module__m-l-16___CDqVb`,
	"mL20": `PatientDetails-module__m-l-20___TmYI8`,
	"mL24": `PatientDetails-module__m-l-24___BTkxq`,
	"mL30": `PatientDetails-module__m-l-30___bAWNy`,
	"mL35": `PatientDetails-module__m-l-35___JMciS`,
	"mL40": `PatientDetails-module__m-l-40___KDYTE`,
	"mR8": `PatientDetails-module__m-r-8___HTvxv`,
	"mR10": `PatientDetails-module__m-r-10___vASYJ`,
	"mR16": `PatientDetails-module__m-r-16___P0NxY`,
	"mR20": `PatientDetails-module__m-r-20___tj5DN`,
	"mR24": `PatientDetails-module__m-r-24___w6Cbw`,
	"mR30": `PatientDetails-module__m-r-30___rOCpC`,
	"mR40": `PatientDetails-module__m-r-40___UmpzM`,
	"borderR3": `PatientDetails-module__border-r-3___peIg4`,
	"borderR4": `PatientDetails-module__border-r-4___DBX34`,
	"borderR6": `PatientDetails-module__border-r-6___TbbV7`,
	"borderR10": `PatientDetails-module__border-r-10___jJdfq`,
	"borderR12": `PatientDetails-module__border-r-12___aVjX_`,
	"borderR16": `PatientDetails-module__border-r-16___Z6yIL`,
	"borderR50": `PatientDetails-module__border-r-50___No3Ly`,
	"primaryBorder": `PatientDetails-module__primary-border___ueYJs`,
	"primaryBorderB": `PatientDetails-module__primary-border-b____vyti`,
	"primaryBorderT": `PatientDetails-module__primary-border-t___Fl5Yk`,
	"primaryBorderL": `PatientDetails-module__primary-border-l___NaW1R`,
	"primaryBorderR": `PatientDetails-module__primary-border-r___BEdJ1`,
	"secondaryBorder": `PatientDetails-module__secondary-border___Skbkp`,
	"secondaryBorderB": `PatientDetails-module__secondary-border-b___yJZdQ`,
	"secondaryBorderT": `PatientDetails-module__secondary-border-t___WywP7`,
	"secondaryBorderL": `PatientDetails-module__secondary-border-l___d28LX`,
	"secondaryBorderR": `PatientDetails-module__secondary-border-r___CWXxL`,
	"gap0": `PatientDetails-module__gap-0___VQIOP`,
	"gap2": `PatientDetails-module__gap-2___v4a8D`,
	"gap4": `PatientDetails-module__gap-4___sGlDf`,
	"gap5": `PatientDetails-module__gap-5___FfdNK`,
	"gap6": `PatientDetails-module__gap-6___P7apg`,
	"gap8": `PatientDetails-module__gap-8___dK8uE`,
	"gap10": `PatientDetails-module__gap-10___EYUba`,
	"gap12": `PatientDetails-module__gap-12___cxVVc`,
	"gap14": `PatientDetails-module__gap-14___AIzY4`,
	"gap16": `PatientDetails-module__gap-16___ItCVv`,
	"gap18": `PatientDetails-module__gap-18___U1ThU`,
	"gap20": `PatientDetails-module__gap-20___hmvkC`,
	"gap24": `PatientDetails-module__gap-24___tZKgj`,
	"gap26": `PatientDetails-module__gap-26___YG8E9`,
	"gap30": `PatientDetails-module__gap-30___L7Hu6`,
	"gap32": `PatientDetails-module__gap-32___mPXnB`,
	"gap40": `PatientDetails-module__gap-40___WgUs1`,
	"gap50": `PatientDetails-module__gap-50___e9yGG`,
	"flex1": `PatientDetails-module__flex-1___EGcSc`,
	"flexNone": `PatientDetails-module__flex-none___ygNx5`,
	"flexColumn": `PatientDetails-module__flex-column___eMoTq`,
	"flexRow": `PatientDetails-module__flex-row___nlJ38`,
	"verticallyCentered": `PatientDetails-module__vertically-centered___rKEAW`,
	"horizontallyCentered": `PatientDetails-module__horizontally-centered___OwzS4`,
	"horizontallyEnd": `PatientDetails-module__horizontally-end___Iq4Wl`,
	"verticallyStart": `PatientDetails-module__vertically-start___N5dMI`,
	"spaceBetween": `PatientDetails-module__space-between___znsHb`,
	"flexWrap": `PatientDetails-module__flex-wrap___L_lR3`,
	"height100": `PatientDetails-module__height-100___pgGfV`,
	"width50": `PatientDetails-module__width-50___Qyn3f`,
	"width100": `PatientDetails-module__width-100___KF3ev`,
	"cursorPointer": `PatientDetails-module__cursor-pointer___NW3Df`,
	"cursorNotAllowed": `PatientDetails-module__cursor-not-allowed___KbP0U`,
	"absoluteCentered": `PatientDetails-module__absolute-centered___ujZpX`,
	"absolute": `PatientDetails-module__absolute___gtNsu`,
	"relative": `PatientDetails-module__relative___tm5eX`,
	"fixed": `PatientDetails-module__fixed___L3lmI`,
	"visible": `PatientDetails-module__visible___s0oRz`,
	"invisible": `PatientDetails-module__invisible___Z7HFW`,
	"col90": `PatientDetails-module__col-90___gRmRr`,
	"colAuto": `PatientDetails-module__col-auto___Kb0dZ`,
	"medicalTabs": `PatientDetails-module__medical-tabs___dSsY4`,
	"medicalTableNew": `PatientDetails-module__medical-table-new___sFqPL`,
	"noPagination": `PatientDetails-module__no-pagination___Htx3D`,
	"medicalTableEmpty": `PatientDetails-module__medical-table-empty___wHRK1`,
	"iconBtn": `PatientDetails-module__icon-btn___HOLt_`,
	"searchIcon": `PatientDetails-module__search-icon___wAXbB`,
	"disableSelect": `PatientDetails-module__disable-select___txWaJ`,
	"breakWord": `PatientDetails-module__break-word___IXdYA`,
	"popupClearBtn": `PatientDetails-module__popup-clear-btn___l0thX`,
	"scrollMB20": `PatientDetails-module__scroll-m-b-20___Uthqt`,
	"section": `PatientDetails-module__section___wwB2Z`,
	"statusText": `PatientDetails-module__statusText___MLvNJ`,
	"yellow": `PatientDetails-module__yellow___G7iQ7`,
	"master": `PatientDetails-module__master___jje2R`,
	"detailSection": `PatientDetails-module__detailSection___Ma9wV`,
	"aside": `PatientDetails-module__aside___T1J58`
};
module.exports = ___CSS_LOADER_EXPORT___;
